/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/

import useCustomRouter from "hooks/useCustomRouter";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import useUsuario from "hooks/useUsuario";
import React, { useEffect } from "react";
import { fetchPhpEigth } from "../../api";
import { ambienteAplicacion, urlResumenCotizadorMex } from "../../constants/urls";
import Loading from "../../wrappers/Loading";

const RecuperarAPIContainer = () => {
  const { addWarningToast } = useCustomToast();
  const usuario = useUsuario();
  const { id: idCotizacion } = useQueryParams();
  const history = useCustomRouter();

  const getData = async () => {
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
      },
      usuCotiza: { usuCodigo: usuario?.cliCodigoCore },
    };

    const resRecuperar = await fetchPhpEigth(urlResumenCotizadorMex, DataResumen);

    if (resRecuperar.transaccion) {
      if (resRecuperar?.cotConsulta?.redireccionar === true) {
        switch (resRecuperar.cotConsulta.pasoCarrito) {
          case "informacionCliente":
            return history.push(
              `/accidentes-planes-personas/${idCotizacion}?recuperar=true`
            );

          case "guardarTotales":
            return history.push(
              `/accidentes-resumen-personas/${idCotizacion}?recuperar=true`
            );

          default:
            break;
        }
      }
      addWarningToast(resRecuperar?.cotConsulta?.mensajeRedireccion);
      return history.push("/");
    } else {
      addWarningToast("Ha ocurrido un problema al recuperar la cotización");
      history.goBack();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Loading loading={true} message='Recuperando...'>
      <h1>Recuperando...</h1>
    </Loading>
  );
};
export default RecuperarAPIContainer;
